import * as $utils from '../../assets/utils/utils'

/**
 * @method 这是路由钩子函数
 * @param { Object } to   到哪里去的路由对象
 * @param { Object } from 从哪里来的路由对象
 * @param { Function } next 路由钩子函数
 */
export default (to, from, next) => {
  if (to.query.appSrc) {
    $utils.sessionCache('appSrc', to.query.appSrc)
  }
  window.scrollTo(0, 0)
  next()
}



// WEBPACK FOOTER //
// ./src/router/route-hook/beforeEach.js